import { render, staticRenderFns } from "./BLErrorCheckPop.vue?vue&type=template&id=1fb71d49&scoped=true"
import script from "./BLErrorCheckPop.vue?vue&type=script&lang=js"
export * from "./BLErrorCheckPop.vue?vue&type=script&lang=js"
import style0 from "./BLErrorCheckPop.vue?vue&type=style&index=0&id=1fb71d49&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb71d49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb71d49')) {
      api.createRecord('1fb71d49', component.options)
    } else {
      api.reload('1fb71d49', component.options)
    }
    module.hot.accept("./BLErrorCheckPop.vue?vue&type=template&id=1fb71d49&scoped=true", function () {
      api.rerender('1fb71d49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLErrorCheckPop.vue"
export default component.exports